import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const postDetailsProService = {
  getpostDetailsPro: async () => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/postDetailsPro`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
    const data = await response.json();
    return data.types;
  },

  updatepostDetailsPro: async (id, updatedField) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/postDetailsPro/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(updatedField),
    });
    const data = await response.json();
    return data;
  },

  deletepostDetailsPro: async (id) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    await fetch(`${API_URL}/postDetailsPro/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
  },

  addpostDetailsPro: async (newField) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/postDetailsPro`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(newField),
    });
    const data = await response.json();
    return data;
  },
};

export default postDetailsProService;
